// Coercion + validation des paramètres de commande, partagées par les vues du
// command bus (CommandActionsModal). Extraites de l'ancien CommandPanel (revue
// MR !2) : la logique y était dupliquée à l'identique.

import { CommandParamSpec } from '../types/commandBus.types'

// Convertit la string saisie en valeur typée selon le spec backend. On reste
// permissif : si la conversion échoue (NaN), on garde la string brute pour que
// la validation côté backend reste la source de vérité.
export const coerceParamValue = (
  raw: string,
  spec: CommandParamSpec,
): unknown => {
  if (spec.type === 'integer') {
    const n = parseInt(raw, 10)
    return Number.isNaN(n) ? raw : n
  }
  if (spec.type === 'number') {
    // ex. fade_seconds, latitude/longitude -- envoyer un nombre JSON, pas la
    // string brute (le momi rejetait les numériques string-typés).
    const n = parseFloat(raw)
    return Number.isNaN(n) ? raw : n
  }
  if (spec.type === 'boolean') {
    return raw === 'true'
  }
  return raw
}

// Valide qu'un input non-vide respecte (a minima) le type déclaré. La regex
// `validation` n'est pas appliquée côté front pour l'instant : on laisse le
// backend renvoyer une erreur claire (affichée via le toast).
export const validateParam = (
  raw: string,
  spec: CommandParamSpec,
): string | null => {
  if (spec.required && raw.trim() === '') return 'Requis'
  if (raw.trim() === '') return null
  if (spec.type === 'integer' && !/^-?\d+$/.test(raw.trim())) {
    return 'Entier attendu'
  }
  return null
}
